import styled from 'styled-components';
import { variables } from '../../../assets/styles/variables';
import { mediaBelow } from '../../../assets/styles/helper';
import themeColors from '../../../assets/styles/themeColors';

const SfhModalTitle = styled.span`
  font-family: ${variables.family.goldSilverHeaders}, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: 16px;
    color: ${themeColors.colorTextPrimary};
  }
`;

export default SfhModalTitle;
